<template lang="pug">
div
	.card
		.card-header.bg-dark.text-white
			.pull-left(v-if="!editando")
				button.btn.btn-sm.btn-warning.mr-3(@click="nuevaOrden()")
					span.fa.fa-edit.mr-1
					|Nueva
			|Información básica
			.badge.badge-success.salvado(:class="(salvado) ? 'activo': ''")
				| Cambios guardados
		.card-body.text-left(v-if="!produccion.anunciante.ID_anunciante")
			.form-group
				label(for="") Anunciante
				input-query(:realtime="true" :input-class="'form-control form-control-sm'" placeholder="Busca el anunciante" :url="'produccion/php/api/buscaAnunciante.php'" @selected="seleccionaAnunciante($event)")
		.card-body.bg-light(v-if="produccion.anunciante.ID_anunciante")
			b Anunciante
			br
			span.text-info(style="font-size:1.3em;font-weight:bold;") {{ produccion.anunciante.nombre }}
			br
			button.btn.btn-sm.btn-danger(@click="quitaAnunciante")
				span.fa.fa-refresh.mr-1
				|Cambiar
		.card-body.bg-danger.text-white.text-left(v-if="produccion.ID_produccion && !produccion.contrato.ID_contrato && hayAnunciante")
			.row.justify-content-between
				.ml-3.align-middle
					b Ningún contrato asociado
				.mr-3
					button.btn.btn-dark.btn-sm(@click="verAsociar = true")
						span.fa.fa-edit.mr-1
						| Asociar
			p.mt-3
				| Cada órden de producción debe estar asociada a un contrato previamente creado.
				| No es necesario que lo asocies en este momento, pero ten en cuenta que no podrás
				| aprobar la producción hasta que hayas hecho este paso.
		.card-body.bg-white.text-center(v-if="produccion.ID_produccion && produccion.contrato.ID_contrato && hayAnunciante")
			b Contrato asociado
			br
			span.text-info(style="font-size:1.3em;font-weight:bold;") {{ produccion.contrato.titulo }}
			br
			| {{ produccion.contrato.nombreCliente }}
			br
			button.btn.btn-sm.btn-danger(@click="cambiaContrato" v-if="permisoEditaContrato")
				span.fa.fa-refresh
				| Cambiar
	.card.mt-3.mb-3(v-if="hayAnunciante")
		.card-header.bg-warning
			| Información de la campaña
		.card-body.text-left
			.form-group
				label(for="") Título de la campaña
				input.form-control.form-control-sm(type="text" placeholder="Título" v-model="produccion.titulo" @blur="guardar()")
			hr
			.form-group
				label(for="") Descripción
				textarea.form-control.form-control-sm(name="" rows="5" @blur="guardar()" v-model="produccion.descripcion" placeholder="Escribe una pequeña descripción que ayude en el proceso de producción")
		.card-body.bg-light
			.row
				.col
					.text-left.mt-2.mb-2(v-if="permisos['produccion_crearPublicas']")
						b Ámbito de la producción
						br
						.btn-group
							button.btn(:class="(!produccion.publica) ? 'btn-danger' : 'btn-default'" @click="setPublica(0)")
								span.fa.fa-lock.mr-1
								| Privada
							button.btn(:class="(produccion.publica) ? 'btn-success' : 'btn-default'" @click="setPublica(1)")
								span.fa.fa-unlock.mr-1
								| Pública
				.col
					.text-left.mt-2(v-if="permisos['produccion_crearExternas']")
						b Tipo de producción
						br
						.btn-group
							button.btn(:class="(!produccion.externa) ? 'btn-danger' : 'btn-default'" @click="setExterna(0)")
								span.fa.fa-flag.mr-1
								| Propia
							button.btn(:class="(produccion.externa) ? 'btn-success' : 'btn-default'" @click="setExterna(1)")
								span.fa.fa-gift.mr-1
								| Producción externa
		.table-responsive(v-if="produccion.ID_produccion")
			table.table.table-striped.table-sm
				thead.bg-danger.text-white
					tr
						th.align-middle Ficheros compartidos entre tareas
						th.text-right
							button.btn.btn-sm.btn-dark(@click="nuevoFichero")
								span.fa.fa-plus
				tbody.text-left
					tr(v-for="fichero in produccion.ficheros" :key="fichero.ID_fichero")
						td {{ fichero.nombre }}
						td.text-right
							button.btn.btn-sm.btn-danger(@click="quitaFichero(fichero.ID_fichero)")
								span.fa.fa-trash
	asocia-contrato(@asignar="asociaContrato($event)" @cerrar="verAsociar = false" v-if="verAsociar")
</template>


<script>
import AsociaContrato from './asocia-contrato'
import API from '../../services/api'
import { mapGetters } from 'vuex'

export default {
	name: 'editor-orden',
	props: ['produccion', 'editando'],
	components: {
		'asocia-contrato': AsociaContrato
	},

	data: function () {
		return {
			verAsociar: false,
			salvado: false
		}
	},

	computed: {
		...mapGetters({
			permisos: 'permisos/permisos'
		}),
		hayAnunciante () {
			return (this.produccion.anunciante.ID_anunciante !== null)
		},

		permisoEditaContrato () {
			// Si tiene permiso para editar siempre los contratos le dejamos
			if (this.permisos.produccion_editaContratosSiempre) {
				return true
			}
			// Podrá editar si todavía no lo ha asociado a ningún contrato
			if (!this.produccion.contrato || !this.produccion.contrato.ID_contrato) {
				return true
			}

			// No podrá editarlo si ya ha finalizado alguna tarea
			for (let i = 0; i < this.produccion.tareas.length; i++) {
				if (this.produccion.tareas[i].fase === 'finalizada') {
					return false
				}
			}

			// En cualquier otro caso, si
			return true
		}
	},

	methods: {

		setPublica (estado) {
			this.produccion.publica = estado
			this.guardar()
		},

		setExterna (estado) {
			this.produccion.externa = estado
			this.guardar()
		},

		nuevaOrden () {
			this.$emit('nueva')
		},

		seleccionaAnunciante (datos) {
			this.produccion.anunciante.ID_anunciante = datos.datos.ID_anunciante
			this.produccion.anunciante.nombre = datos.datos.nombre
			this.guardar()
		},
		quitaAnunciante () {
			this.produccion.anunciante = {
				ID_anunciante: null,
				nombre: null
			}
		},
		asociaContrato (datos) {
			this.produccion.contrato.ID_contrato = datos.ID_contrato
			this.produccion.contrato.titulo = datos.titulo
			this.produccion.contrato.nombreCliente = datos.nombreCliente
			this.verAsociar = false

			this.guardar()
		},
		cambiaContrato () {
			this.produccion.contrato = {
				ID_contrato: null,
				titulo: null
			}
		},

		nuevoFichero () {
			const inp = document.createElement('input')
			inp.type = 'file'
			inp.setAttribute('multiple', 'true')
			inp.addEventListener('change', (ev) => {
				const form = new FormData()
				form.append('ID_produccion', this.produccion.ID_produccion)
				const ficheros = ev.srcElement.files

				for (let i = 0; i < ficheros.length; i++) {
					form.append('fichero[]', ficheros[i])
				}

				// enviamos
				API.setFicherosProduccion(form)
					.then(res => {
						// this.produccion = res.data.produccion
						this.$emit('update:produccion', res.data.produccion)
						this.emiteActualizar()
					})
					.catch(e => {
						console.error(e)
					})

				document.body.removeChild(inp)
			})
			inp.style.display = 'none'

			document.body.appendChild(inp)

			inp.click()
		},

		quitaFichero (idFichero) {
			this.$store.commit('alertas/confirm', {
				titulo: 'Confirmación',
				mensaje: '¿Quieres eliminar este fichero?\n\nEsta acción no se puede deshacer',
				callback: (acepta) => {
					if (acepta) {
						const datos = {
							ID_produccion: this.produccion.ID_produccion,
							ID_fichero: idFichero
						}

						API.delFicherosProduccion(datos)
							.then(res => {
								// this.produccion = res.data.produccion
								this.$emit('update:produccion', res.data.produccion)
								this.emiteActualizar()
							})
							.catch(e => {
								this.$store.commit('alertas/alert', {
									titulo: 'Error',
									mensaje: e.response.data.error
								})
							})
					}
				}
			})
		},

		guardar () {
			if (!this.produccion.anunciante.ID_anunciante) {
				console.error('Debes seleccionar un anunciante')
				return
			}

			if (!this.produccion.titulo) {
				console.error('Debes proporcionar un título')
				return
			}

			if (!this.produccion.contrato.ID_contrato) {
				console.info('No has asociado la producción a ningún contrato.\n\nTen en cuenta que deberás hacerlo antes de finalizarla')
			}

			API.setProduccion(this.produccion)
				.then(res => {
					this.emiteActualizar()
					this.$emit('update:produccion', res.data.produccion)
				})
				.catch(e => {
					console.error(e)
				})
		},

		emiteActualizar () {
			this.$emit('actualizar')

			this.salvado = true

			window.setTimeout(() => {
				this.salvado = false
			}, 2000)
		}
	}
}
</script>


<style scoped>

	.salvado {
		transition-property: opacity;
		transition-duration: 300ms;
		opacity: 0;

		position: absolute;
		display: block;
		right: 3px;
		top: 13px;
		font-size: 0.8em;
		padding: 5px;
		border-radius: 4px;
	}

	.salvado.activo {
		opacity: 1;
	}
</style>



// WEBPACK FOOTER //
// src/modulos/produccion/vue/components/nueva/orden.vue